// extracted by mini-css-extract-plugin
export default {"component":"Tag_component__E3cAN","started":"Tag_started__6orGN","stopped":"Tag_stopped__wvKgu","completed":"Tag_completed__QDF8C"};